import json from 'Src/util/json'
import {
  isSupported
} from 'Src/util/tool'

import LegalText from 'Src/const/cross-end-delivery-words/index'
// 支持搜索广告
const isSearchAdv = json.catchableParse(GLOBAL_VAR.adv_search_tag)
// 有搜索快投权限
const isFeed2Search = !isSupported(GLOBAL_VAR.adver_func.SearchAdDeliveryDisable)
// 轮询任务名称
export const PromotionsPollingTaskName = {
  AD_BATCH_UPDATE: 'ad_batch_update'
}

export const TaskType = {
  sync: 0,
  async: 1
}

// 计划下 table 的第一列的选择类型
export const adSelectedType = {
  head: 'head', // 点击头部 checkbox
  body: 'body', // 点击单条数据选中
  currentPage: 'currentPage', // 选着头部的下拉中的当前页
  allPage: 'allPage' // 选着头部的下拉中的所有
}

export const allBatchType = {
  pricing: 'pricing',
  deepcpabid: 'deepcpabid',
  budget: 'budget',
  schedule: 'schedule',
  time: 'time',
  age: 'age',
  district: 'district',
  smart_choice_traffic: 'smart_choice_traffic',
  search_auto_update_keyword: 'search_auto_update_keyword',
  feed_to_search: 'feed_to_search',
  // 组和计划的否定词操作字面量跟 privative-set-new/const.js privative-set/const.js 中定义的保持一致，后期会下掉 privative-set，只需要跟 privative-set-new/const.js 中定义的常量值保持一致
  ad_privative_set: 'ad_privative_set', // 计划-批量-追加
  ad_privative_replace: 'ad_privative_replace', // 计划-批量-替换
  ad_privative_add: 'ad_privative_add', // 计划-单个-设置
  word_bid: 'word_bid',
  match_type: 'match_type',
  enable: 'enable',
  disable: 'disable',
  delete: 'delete',
  video_sync: 'video_sync'
}

// 异步任务批量操作
export const asyncTaskOperateDes = {
  [allBatchType.enable]: $bp_t('启用', 'common.enable'),
  [allBatchType.disable]: $bp_t('停用', 'common.pause'),
  [allBatchType.delete]: $bp_t('删除', 'common.delete'),
  [allBatchType.pricing]: $bp_t('修改出价', 'common.revised_bid'),
  [allBatchType.deepcpabid]: $bp_t('修改深度转化出价', 'bp.modify_dpa_bid'),
  [allBatchType.budget]: $bp_t('修改预算', 'common.budget_revision'),
  [allBatchType.schedule]: $bp_t('修改投放时间', 'bp.promotion_modify_release_time'),
  [allBatchType.time]: $bp_t('修改投放时段', 'bp.promotion_moodify_week_time'),
  [allBatchType.age]: $bp_t('修改年龄', 'common.change_age'),
  [allBatchType.district]: $bp_t('修改地域', 'common.chage_district'),
  [allBatchType.smart_choice_traffic]: $bp_t('修改智选流量', 'common.change_smart_choice'),
  [allBatchType.search_auto_update_keyword]: '修改自动加词',
  [allBatchType.feed_to_search]: $bp_t('开启搜索快投', 'common.feed_to_search'),
  [allBatchType.ad_privative_replace]: $bp_t('替换否定词', 'bp.promotion_replace_priviate_word'),
  [allBatchType.ad_privative_set]: $bp_t('添加否定词', 'bp.promotion_ad_privative_set'),
  [allBatchType.video_sync]: '创意视频引用'
}

export const AD_BATCH_TASK_STATUS = {
  WATING: 1,
  PENDING: 2,
  DONE: 3,
  CANCLED: 4
}

// 关键词导航类型属性
const PromotionKeywordType = {
  keyword: {
    icon: 'keyword',
    value: 4,
    router: 'keyword',
    text: '关键词',
    shortcut: 'Alt+4'
  }
}

export const PromotionTypes = {
  ...{
    campaign: {
      icon: 'campaign',
      value: 1,
      router: 'campaign',
      text: $bp_t('广告组', 'common.advertising_group'),
      shortcut: 'Alt+1'
    },
    ad: {
      icon: 'plan',
      value: 2,
      router: 'ad',
      text: $bp_t('计划', 'common.plan'),
      shortcut: 'Alt+2'
    },
    creative: {
      icon: 'creative',
      value: 3,
      router: 'creative',
      text: $bp_t('创意', 'common.originality'),
      shortcut: 'Alt+3'
    }
  },
  ...(isSearchAdv ? PromotionKeywordType : {})
}

export const KeyWordSearchType = {
  phrase: 'phrase',
  term: 'term'
}

export const StatMethod = {
  TOTAL: 0,
  BY_DAY: 1,
  BY_HOUR: 2
}

export const SortOrder = {
  asc: 0,
  desc: 1
}

export const LearningPhaseStatus = {
  0: {
    status: $bp_t('无', 'common.nothing'),
    detail: '',
    style: 'status_fail'
  },
  1: {
    status: $bp_t('学习期', 'common.learning_period'),
    detail: $bp_t('当前计划正处于学习期，系统将为您探索潜在的目标用户。', 'common.current_plan_in_learning_period'),
    style: 'status_success'
  },
  2: {
    status: $bp_t('学习期结束', 'common.end_of_study_period'),
    detail: $bp_t('当前计划已结束学习期。', 'common.current_program_ended_learning_period'),
    style: 'status_success'
  },
  3: {
    status: $bp_t('学习期失败', 'common.learning_period_failure'),
    detail: $bp_t('当前计划系统未成功探索到目标人群，学习失败。', 'common.current_planning_system_failed_to_explore'),
    style: 'status_fail'
  }
}

export const LearningPhaseStatusSearch = {
  ...LearningPhaseStatus,
  1: {
    status: $bp_t('学习期', 'common.learning_period'),
    detail: $bp_t('当前搜索计划正处于学习期，系统将基于搜索流量为您探索潜在的目标用户。', ''),
    style: 'status_success'
  }
}

export const HouseKeeperProtectStatus = {
  0: {
    status: '',
    detail: '',
    style: ''
  },
  1: {
    status: '',
    detail: '成本保障生效中',
    style: 'status_primary'
  },
  2: {
    status: '',
    detail: '成本保障确认中',
    style: 'status_primary'
  },
  3: {
    status: '',
    detail: '',
    style: ''
  },
  4: {
    status: '',
    detail: '成本保障已失效',
    style: 'status_primary'
  },
  5: {
    status: '',
    detail: '成本保障已结束',
    style: 'status_primary'
  }
}

export const CostProtectStatus = {
  0: {
    status: $bp_t('无', 'common.nothing'),
    detail: '',
    style: 'status_primary'
  },
  1: {
    status: $bp_t('成本保障生效中', 'common.cost_guarantee_in_effect'),
    detail: $bp_t('系统对探索过程中的超成本风险进行了保障，对于超成本较高的情况将进行赔付。', 'common.system_guarantees_the_risk_of_over_cost'),
    style: 'status_primary'
  },
  2: {
    status: $bp_t('成本保障计算中', 'common.cost_guarantee_calculation'),
    detail: $bp_t('系统正在检查该计划是否可以赔付并计算相应金额，若满足赔付条件，赔付金额将在第二天到账，请您耐心等待。', 'common.compensation_conditions_met'),
    style: 'status_primary'
  },
  3: {
    status: $bp_t('成本保障已到账', 'common.cost_guarantee_has_arrived'),
    detail: $bp_t('该计划在投放期间，满足自动赔付规则，赔付已到账，详见站内信。', 'common.compensation_has_arrived'),
    style: 'status_primary'
  },
  4: {
    status: $bp_t('成本保障已失效', 'common.cost_guarantee_is_invalid'),
    detail: $bp_t('由于该计划修改出价和定向次数过多，已失去自动赔付资格。', 'common.lost_automatic_compensation_qualification'),
    style: 'status_fail'
  },
  5: {
    status: $bp_t('成本保障已结束', 'common.cost_protection_is_over'),
    detail: $bp_t('该计划已通过成本保障期，将由系统出价控制成本，不再进行自动赔付。', 'common.passed_cost_guarantee_period'),
    style: 'status_primary'
  }
}

export const CampaignType = {
  1: $bp_t('所有广告', 'common.information_flow'),
  2: $bp_t('搜索广告', 'common.search')
}

// 默认状态查询参数-不限（不包含已删除）
// 参考 src/components/promotion/all-filters-options.js
export const DefaultStatus = {
  campaign: [1],
  ad: [0],
  creative: [0],
  keyword: [0]
}

export const PromotionHeaderTips = {
  distinct_ad_id: '使用当前素材进行投放的广告计划个数，仅记录有投放数据的计划个数',
  distinct_creative_id: '使用当前素材进行投放的广告创意个数，仅记录有投放数据的创意个数',
  advertiser_name: '对应广告账户的名称',
  advertiser_remark: '对应广告账户的备注',
  advertiser_id: '对应广告账户的ID',
  campaign_name: $bp_t('对应广告组的名称', 'bp.promotion_promotion_state_campaign_name'),
  landing_type: $bp_t('对应广告组的推广目的', 'bp.promotion_promotion_state_campagin_target'),
  campaign_type: $bp_t('对应广告组的类型', 'bp.promotion_promotion_state_campaign_type'),
  campaign_budget: $bp_t('对应广告组一天可消耗的最高预算', 'bp.promotion_promotion_state_campaign_budget'),
  campaign_id: $bp_t('对应广告组的组ID', 'bp.promotion_promotion_state_campaign_id'),
  campaign_status: $bp_t('对应广告组的当前状态', 'bp.promotion_promotion_state_campaign_status'),
  ad_name: $bp_t('对应广告计划的名称', 'bp.promotion_promotion_state_project_name'),
  ad_status: $bp_t('对应广告计划的当前状态', 'bp.promotion_promotion_state_project_status'),
  suggestion: $bp_t('广告的审核建议，请注意并不是只有审核拒绝才有建议，投放中的广告也可能有建议，帮助你进一步优化和规避风险', 'bp.promotion_promotion_state_reject_advice'),
  ad_budget: $bp_t('对应广告计划一天可消耗的最高预算', 'bp.promotion_promotion_state_maxnuim_cost_day'),
  bid: $bp_t('对应广告计划所设置的出价，即您愿意为每次广告展示所支付的费用', 'bp.promotion_promotion_state_set_budget'),
  pre_convert_count: $bp_t('系统根据您所选时间范围内展示的广告所触达的人群，通过算法来预估未来将会产生的总转化数（会将当前尚未转化，但未来可能转化的数据统计进来）。当转化成本偏高时，建议参考预估转化成本。', 'bp.promotion_promotion_state_estimate_audience'),
  ad_id: $bp_t('对应广告计划的计划ID', 'bp.promotion_promotion_state_project_id'),
  flow_control_mode: $bp_t('对应广告计划的投放方式设置的投放方式', 'bp.promotion_promotion_state_target_method'),
  delivery_scene_name: $bp_t('对应计划设置的投放场景-竞价策略', 'bp.delivery_scene_ad_settine'),
  delivery_range: $bp_t('对应广告计划所选择的投放范围', 'bp.promotion_promotion_state_target_area'),
  start_time: $bp_t('对应广告计划投放的开始和结束日期', 'bp.promotion_promotion_state_target_time_range'),
  download_type: $bp_t('对应广告计划设置的下载方式', 'bp.promotion_promotion_state_download_mode'),
  download_url: $bp_t('对应广告计划推广的应用下载链接', 'bp.promotion_promotion_state_project_download_url'),
  external_url: $bp_t('对应广告计划推广的落地页链接', 'bp.promotion_promotion_state_project_external_url'),
  web_url: $bp_t('对应广告计划推广的应用下载详情页', 'bp.promotion_promotion_state_project_download_detail'),
  external_action: $bp_t('对应广告计划设定的转化事件目标，用户完成一次转化目标即记录一次转化', 'bp.promotion_promotion_state_project_set_convert'),
  diagnosis: $bp_t('帮助广告主判断计划投放效果，定位投放问题，并给出相应的优化建议', 'bp.promotion_promotion_state_project_diagnosis'),
  action_track_url: $bp_t('对应广告计划所设置的转化监督链接', 'bp.promotion_promotion_state_project_track_url'),
  app_code_name: LegalText.reports.delivery_postion_tip,
  creative_status: $bp_t('对应广告创意的当前状态', 'bp.promotion_promotion_state_creative_status'),
  creative_id: $bp_t('对应广告创意的创意ID', 'bp.promotion_promotion_state_creative_id'),
  show_cnt_tgi: 'TGI(Target Group Index) = 受众中某标签占比 / 大盘人群中某标签占比 * 100',
  click_cnt_tgi: 'TGI(Target Group Index) = 受众中某标签占比 / 大盘人群中某标签占比 * 100',
  convert_cnt_tgi: 'TGI(Target Group Index) = 受众中某标签占比 / 大盘人群中某标签占比 * 100',
  deep_convert_cnt_tgi: 'TGI(Target Group Index) = 受众中某标签占比 / 大盘人群中某标签占比 * 100',
  budget_low: $bp_t('该（计划/组）消耗超过预算的80%，为避免影响正常投放，请合理调整预算。', 'common.adjust_the_budget_reasonably'),
  show_cnt: $bp_t('广告展示给用户的次数。计算方式：经平台判定有效且被计费的展示次数。', 'bp.promotion_promotion_state_show_times'),
  click_cnt: $bp_t('当头条用户点击广告素材时，触发点击事件，该事件被认为是一次有效的广告点击。', 'bp.promotion_promotion_state_once_effect_click'),
  ctr: $bp_t('广告被点击的次数占展示次数的百分比。计算方法：点击数/展示数*100%', 'common.percentage_of_times_click'),
  cpc_platform: $bp_t('广告主为每次点击付出的费用成本，计算公式是：总花费/点击数。', 'bp.promotion_promotion_state_CPC'),
  cpm_platform: $bp_t('广告平均每一千次展现所付出的费用，计算公式是：总花费/展示数*1000。', 'bp.promotion_promotion_state_CPM'),
  stat_cost: $bp_t('表示广告在投放期内的预估花费金额。当天数据可能会有波动，次日稳定', 'bp.promotion_promotion_state_estimate_budget_fluctuation'),
  convert_cnt: $bp_t('将转化数记录在转化事件发生的时间上。建议广告主考核成本时参考“转化数据（计费时间）”例如您的广告在早上8点进行了展示和点击，用户晚上19点发生了激活行为，我们会把激活数披露在晚上19点。', 'bp.promotion_promotion_state_time_on_convert'),
  conversion_cost: $bp_t('广告主为每个转化所付出的平均成本，计算方式：总花费/转化数。当天数据可能会有波动。', 'bp.promotion_promotion_state_convert_average_cost'),
  conversion_rate: $bp_t('广告被用户转化的次数占点击次数的百分比。计算方式：转化数/点击数*100%', 'bp.promotion_promotion_state_convert_click_radio'),
  deep_convert_cnt: $bp_t('将深度转化数记录在转化事件发生的时间上。建议广告主考核深度转化成本时参考“深度转化数（计费时间）”例如您的广告在早上8点进行了展示和点击，用户晚上19点发生了激活行为，我们会把激活数披露在晚上19点。', 'bp.promotion_promotion_state_convert_event_time'),
  deep_convert_cost: $bp_t('广告主为每个深度转化所付出的平均成本，计算方法：总花费/深度转化数。当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_promotion_state_deep_convert_pay_cost'),
  deep_convert_rate: $bp_t('广告被用户进行深度转化的次数占转化次数的百分比。计算方式：深度转化数/转化数*100%', 'bp.promotion_promotion_state_deep_convert_convert_radio'),
  attribution_convert_cnt: $bp_t('在转化行为发生（或回传）后，将转化行为回记到过去7天内的扣费（消耗产生）时间上。 例如：广告在8月20日展示给用户，此时广告花费10元，用户点击广告后于8月23日产生1笔购买，则8月23日这笔购买将会展示在8月20日，8月23日没有转化数。暂不支持查看当日数据。 ', 'bp.promotion_state_attribution_convert_cnt'),
  attribution_convert_cost: $bp_t('转化成本(计费时间) = 消耗 / 转化数(计费时间)。例如：广告在8月20日展示给用户，此时广告花费10元，用户点击广告后，于8月23日产生2笔购买，则8月20日的转化成本（计费时间） = 5元（即10元除以2笔）。成本考核和系统赔付以该指标为准，暂不支持查看当日数据。', 'bp.promotion_state_attribution_convert_cost'),
  attribution_deep_convert_cnt: $bp_t('在转化行为发生（或回传）后，将转化行为回记到过去7天内的扣费（消耗产生）时间上。 例如：广告在8月20日展示给用户，此时广告花费10元，用户点击广告后于8月23日产生1笔购买，则8月23日这笔购买将会展示在8月20日。暂不支持查看当日数据。', 'bp.promotion_state_attribution_deep_convert_cnt'),
  attribution_deep_convert_cost: $bp_t('是一个准确的深度转化成本评估指标。计算方式：消耗 / 深度转化数(计费时间)。例如：广告在8月20日展示给用户，此时广告花费10元，用户点击广告后，于 8 月 23 日产生2笔购买，则8月20日的深度转化成本（计费时间） = 5元（即10元除以2笔）。成本考核和系统赔付以该指标为准，暂不支持查看当日数据。', 'bp.promotion_state_attribution_deep_convert_cost'),
  click_start_cnt: $bp_t('用户在落地页中开始安装包下载进程的次数，仅安卓下载可以监测到该行为', 'bp.promotion_promotion_state_click_start_cn'),
  click_start_cost: $bp_t('计算方法：总花费/安卓下载开始数。', 'bp.promotion_promotion_state_click_start_cost'),
  click_start_rate: $bp_t('计算方法：安卓下载开始数/点击数', 'bp.promotion_promotion_state_click_start_rate'),
  download_finish_cnt: $bp_t('用户在落地页中下载安装包进程完成的次数，仅安卓下载可以监测到该行为', 'bp.promotion_promotion_state_install_finish'),
  download_finish_cost: $bp_t('计算方式：总花费/安卓下载完成数。', 'bp.promotion_promotion_download_finish_cost'),
  download_finish_rate: $bp_t('计算方式：安卓下载完成数/安卓下载开始数', 'bp.promotion_promotion_state_download_finish_rate'),
  install_finish_cnt: $bp_t('用户在落地页中将安装包安装完成的次数，仅安卓下载可以监测到该行为', 'bp.promotion_promotion_state_install_finish_cnt'),
  install_finish_cost: $bp_t('计算方式：总花费/安卓安装完成数', 'bp.promotion_promotion_state_install_finish_cost'),
  install_finish_rate: $bp_t('计算方式：安卓安装完成数/安卓下载完成数', 'bp.promotion_promotion_state_install_finish_rate'),
  active: $bp_t('如果您对接了API，激活数是您认可且回传成功的的激活数。如果您对接了SDK，则激活数是指用户下载您的APP后打开的次数。', 'bp.promotion_promotion_state_active'),
  active_cost: $bp_t('计算方式：总花费/激活数。', 'bp.promotion_promotion_state_active_cost'),
  active_rate: $bp_t('计算方式：激活数/点击数*100%', 'bp.promotion_promotion_state_active_rate'),
  active_register: $bp_t('如果您对接了API，注册数是您认可且回传成功的的注册数。如果您对接了SDK，则注册数是用户实现注册行为的次数，详情见「SDK对接文档」', 'bp.promotion_promotion_state_active_register'),
  active_register_cost: $bp_t('广告主为每个注册所付出的成本，计算公式是：总花费/注册数，当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_promotion_state_active_register_cost'),
  active_register_rate: $bp_t('注册用户占激活用户的比例', 'bp.promotion_promotion_state_active_register_rate'),
  next_day_open: $bp_t('根据您通过api或sdk回传给我们的时间为准，将次留数披露在回传时间。', 'bp.promotion_promotion_state_next_day_open'),
  attribution_next_day_open_cnt: $bp_t('在次留行为发生或回传后，将次留数匹配到相应的激活时间上，用来查看当天在第二天的次留数。当天数据不产出。', 'bp.promotion_promotion_state_attribution_next_day_open_cnt'),
  attribution_next_day_open_cost: $bp_t('次留成本=消耗/次留数', 'bp.promotion_promotion_state_attribution_next_day_open_cost'),
  attribution_next_day_open_rate: $bp_t('次留率=次留数/激活数', 'bp.promotion_promotion_state_attribution_next_day_open_rate'),
  game_addiction: $bp_t('有APP内关键行为的用户数量', 'common.number_of_users_with_key_behaviors'),
  game_addiction_cost: $bp_t('广告主为每个有APP内关键行为的用户所付出的成本，计算公式是总花费/关键行为数。当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_promotion_state_game_addiction_cost'),
  game_addiction_rate: $bp_t('关键行为用户占激活用户的比例', 'common.proportion_of_key_behavior_users'),
  active_pay: $bp_t('用户在应用内首次完成付费的次数', 'bp.promotion_promotion_state_active_pay'),
  active_pay_cost: $bp_t('用户在应用内首次完成付费的成本，计算方式：消耗/首次付费数。', 'bp.promotion_promotion_state_active_pay_cost'),
  active_pay_rate: $bp_t('计算方式：首次付费数/激活数。', 'bp.promotion_promotion_state_active_pay_rate'),
  loan_completion: $bp_t('互联网金融-贷款行业中，用户成功提交贷款额度申请的行为', 'bp.promotion_promotion_state_loan_completion'),
  loan_credit: $bp_t('互联网金融-贷款行业中，用户提交贷款额度申请后，广告主审批通过，给予用户可贷款的额度', 'bp.promotion_promotion_state_loan_credit'),
  pre_loan_credit: $bp_t('互联网金融-贷款行业中，用户提交一部分个人信息后，广告主初步审批通过，并引导用户进行更加详细的信息填写以完成最终授信', 'bp.promotion_promotion_state_pre_loan_credit'),
  loan_completion_rate: $bp_t('计算方式：完件数／注册数', 'bp.promotion_promotion_state_completed_pieces'),
  loan_credit_rate: $bp_t('计算方式：授信数／完件数', 'bp.promotion_promotion_state_credit_number'),
  loan_completion_cost: $bp_t('计算方式：总花费／完件数。当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_state_loan_completion_cost'),
  loan_credit_cost: $bp_t('计算方式：总花费／授信数。当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_state_loan_credit_cost'),
  pre_loan_credit_cost: $bp_t('计算方式：总花费／预授信数。当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_state_pre_loan_credit_cost'),
  in_app_uv: $bp_t('用户调起APP后到达的次数，一般在DPA广告中使用', 'bp.promotion_promotion_state_in_app_uv'),
  in_app_detail_uv: $bp_t('用户调起APP后到达指定详情页的次数，一般在DPA广告中使用', 'bp.promotion_promotion_state_in_app_detail_uv'),
  in_app_cart: $bp_t('用户调起APP后加入购物车的次数，一般在DPA广告中使用', 'bp.promotion_promotion_state_in_app_cart'),
  in_app_order: $bp_t('用户调起APP后提交订单的次数，一般在DPA广告中使用', 'bp.promotion_promotion_state_in_app_order'),
  in_app_pay: $bp_t('用户调起APP后完成付费的次数，一般在DPA广告中使用', 'bp.promotion_promotion_state_in_app_pay'),
  phone: $bp_t('用户点击POI页面的电话按钮的次数', 'bp.promotion_promotion_state_phone'),
  form: $bp_t('用户在门店落地页多线沟通提交表单的次数', 'bp.promotion_promotion_state_form'),
  map: $bp_t('用户进行地图搜索的次数', 'bp.promotion_promotion_state_map'),
  button: $bp_t('用户点击按钮button的次数', 'bp.promotion_promotion_state_button'),
  view: $bp_t('用户在关键页面的浏览次数', 'bp.promotion_promotion_state_view'),
  download_start: $bp_t('用户点击下载开始的次数', 'bp.promotion_promotion_state_download_start'),
  qq: $bp_t('用户点击QQ咨询按钮的次数', 'bp.promotion_promotion_state_qq'),
  lottery: $bp_t('用户点击抽奖按钮的次数', 'bp.promotion_promotion_state_lottery'),
  vote: $bp_t('用户点击投票按钮的次数', 'bp.promotion_promotion_state_vote'),
  message: $bp_t('用户点击短信咨询的次数', 'bp.promotion_promotion_state_message'),
  redirect: $bp_t('用户跳转至其他页面的次数', 'bp.promotion_promotion_state_redirect'),
  shopping: $bp_t('用户购买商品的次数', 'bp.promotion_promotion_state_shopping'),
  consult: $bp_t('用户点击在线咨询按钮的次数', 'bp.promotion_promotion_state_consult'),
  wechat: $bp_t('用户通过长按复制微信号的次数', 'bp.promotion_promotion_state_wechat'),
  phone_confirm: $bp_t('用户点击确认拨打电话按钮的次数', 'bp.promotion_promotion_state_phone_confirm'),
  phone_connect: $bp_t('用户在门店落地页点击多线沟通的电话按钮并接通的次数', 'bp.promotion_promotion_state_phone_connect'),
  consult_effective: $bp_t('用户在门店落地页多线沟通的在线咨询中有效咨询的次数', 'bp.promotion_promotion_state_consult_effective'),
  coupon: $bp_t('用户点击POI页面卡券领取按钮的次数', 'bp.promotion_promotion_state_coupon'),
  coupon_single_page: $bp_t('用户点击卡券页领取按钮的次数', 'bp.promotion_promotion_state_coupon_single_page'),
  luban_order_cnt: $bp_t('该条广告产生的订单数量', 'bp.promotion_promotion_state_luban_order_cnt'),
  luban_order_stat_amount: $bp_t('该条广告产生订单的实际销售金额，不含优惠券和退款。当前仅支持商品推广的计划', 'bp.promotion_promotion_state_luban_order_stat_amount'),
  luban_order_roi: $bp_t('计算公式：订单金额/广告消耗。当前仅支持商品推广的计划', 'bp.promotion_promotion_state_luban_order_roi'),
  redirect_to_shop: $bp_t('用户调起第三方店铺的次数', 'bp.promotion_promotion_state_redirect_to_shop'),
  poi_collect: $bp_t('用户点击POI页面的收藏按钮的次数', 'bp.promotion_promotion_state_poi_collect'),
  poi_address_click: $bp_t('用户点击顶部地图图标区域展开详细地图/点击图片下方地址展开详细地图/点击图片下方地址展开详细地图的次数', 'bp.promotion_promotion_state_poi_address_click'),
  total_play: $bp_t('播放时间大于0S的数量，在某些蜂窝网络环境下，需要您手动点击开始才会开始播放，因此有时播放数小于展示数。', 'bp.promotion_promotion_state_total_play'),
  valid_play: '竞价广告播放时间大于等于10秒的数量，如果视频总时长不足10秒，则记录播放完成的次数。品牌广告在部分APP（头条、头条lite、抖音、西瓜、抖音火山版、皮皮虾）播放时间大于等于5秒的数量，在其他APP大于等于3秒的数量，如果视频总时长不足5秒/3秒时，则记录播放完成的次数。',
  valid_play_cost: $bp_t('计算公式：总花费/有效播放数，当天数据可能会有波动，次日早8点后稳定。', 'bp.promotion_promotion_state_valid_play_cost'),
  valid_play_rate: $bp_t('计算公式：有效播放数/展示数。', 'bp.promotion_promotion_state_valid_play_rate'),
  average_play_time_per_play: $bp_t('计算方法：视频播放总实际时长／播放总次数（不包含跳跃的时长）', 'bp.promotion_promotion_state_average_play_time_per_play'),
  play_25_feed_break: $bp_t('用户播放至视频长度25%及以上的次数，包括跳跃播放至此长度的播放次数', 'bp.promotion_promotion_state_play_twentyFive_feed_break'),
  play_50_feed_break: $bp_t('用户播放至视频长度50%及以上的次数，包括跳跃播放至此长度的播放次数', 'bp.promotion_promotion_state_play_fifty_feed_break'),
  play_75_feed_break: $bp_t('用户播放至视频长度75%及以上的次数，包括跳跃播放至此长度的播放次数', 'bp.promotion_promotion_state_play_seventyFive_feed_break'),
  play_99_feed_break: $bp_t('用户播放至视频长度99%及以上的次数，包括跳跃播放至此长度的播放次数', 'bp.promotion_promotion_state_play_ninetyNine_feed_break'),
  wifi_play_rate: $bp_t('在wifi环境下视频的播放数/视频播放总数', 'bp.promotion_promotion_state_wifi_play_rate'),
  click_call_cnt: $bp_t('用户查看创意的附加创意后，点击电话拨打按钮的次数', 'bp.promotion_promotion_state_click_call_cnt'),
  click_counsel: $bp_t('用户查看创意的附加创意后，点击在线咨询的次数', 'bp.promotion_promotion_state_click_counsel'),
  form_submit: $bp_t('用户查看创意的附加创意后，提交表单的次数', 'bp.promotion_promotion_state_form_submit'),
  form_click_button: $bp_t('用户查看创意的附加创意后，点击表单提交按钮的次数', 'bp.promotion_promotion_state_form_click_button'),
  coupon_addition: $bp_t('用户查看创意的附加创意后，领取卡券的次数', 'bp.promotion_promotion_state_coupon_addition'),
  dy_share: $bp_t('用户把分享广告到其他社交媒体的次数，成功完成一次分享行为记一次分享数', 'bp.promotion_promotion_state_dy_share'),
  dy_comment: $bp_t('用户在评论区对广告创意输入评论并点击提交的次数，仅限有评论区的APP（西瓜目前没有评论区）', 'bp.promotion_promotion_state_dy_comment'),
  dy_like: $bp_t('广告被用户点赞的数量', 'bp.promotion_promotion_state_dy_like'),
  message_action: $bp_t('用户在广告主抖音号主页中发起私信的次数，按人次记数', 'bp.promotion_promotion_state_message_action'),
  dy_follow: $bp_t('广告被受众新增关注的数量，目前抖音、头条号外、微头条、抖音火山版可新增关注', 'bp.promotion_promotion_state_dy_follow'),
  dy_home_visited: $bp_t('点击广告头像进入主页进行访问的次数，目前抖音、头条号外、抖音火山版可进行主页访问', 'bp.promotion_promotion_state_dy_home_visited'),
  click_shopwindow: $bp_t('用户在广告主抖音号主页中访问商品橱窗的次数', 'bp.promotion_promotion_state_click_shopwindow'),
  click_landing_page: $bp_t('用户在广告主抖音号主页内访问落地页的次数', 'bp.promotion_promotion_state_click_landing_page'),
  click_download: $bp_t('用户在广告主抖音号主页内点击下载的次数', 'bp.promotion_promotion_state_click_download'),
  click_call_dy: $bp_t('用户在广告主抖音号主页内点击电话拨打的次数', 'bp.promotion_promotion_state_click_call_dy'),
  ies_challenge_click: $bp_t('抖音广告中，用户点击挑战赛查看的数量', 'bp.promotion_promotion_state_ies_challenge_click'),
  ies_music_click: $bp_t('抖音广告中，用户点击音乐查看的数量', 'bp.promotion_promotion_state_ies_music_click'),
  location_click: $bp_t('抖音广告中，用户点击POI组件的次数，一般出现在信息流或评论页面。POI为Point of Interest缩写', 'bp.promotion_promotion_state_location_click'),
  deep_external_action: $bp_t('对应广告计划设置的深度转化目标', 'bp.promotion_promotion_state_deep_external_action'),
  deep_cpabid: $bp_t('对应广告计划设置的深度转化出价', 'bp.promotion_promotion_state_deep_capbid'),
  roi_goal: '对应广告计划设置的ROI系数',
  ladingTypeStoreVersion2: $bp_t('门店推广2.0已上线，已有的门店推广老计划不再支持投放、更改、复制、编辑，请前往门店管理重新设置门店并新建计划进行投放', 'bp.promotion_promotion_state_store_version_two'),
  externalBanCopyReason: $bp_t('原落地页推广目的中的应用下载类计划不支持复制，如有需要请在APP推广目的中新建以落地页为下载方式的计划', 'bp.promotion_promotion_state_externalBanCopyReason'),
  click_website: $bp_t('用户在广告主抖音号主页内访问落地页的次数', 'bp.promotion_promotion_state_click_landing_page'),
  luban_roi_goal: '开启鲁班ROI计划后，设置的目标ROI数值',
  luban_roi_status: '若计划使用ROI系数进行优化，则该列将显示该计划所处的阶段',
  luban_live_enter_cnt: '用户进入您直播间的次数',
  luban_live_follow_cnt: '您的直播间新增的关注数，目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  luban_live_slidecart_click_cnt: '用户在您的直播间点击查看购物车的次数，目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  stat_union_ltv_0: '所选时间范围内的激活用户在激活当日的变现金额，该指标隔日产出，并做了模糊化处理',
  stat_union_ltv_3: '所选时间范围内的激活用户在激活后三天内的变现金额总和，该指标隔日产出，并做了模糊化处理',
  stat_union_ltv_7: '所选时间范围内的激活用户在激活后七天内的变现金额总和，该指标隔日产出，并做了模糊化处理',
  union_roi_0: '所选时间范围内的激活用户在激活当日的广告变现ROI，计算公式是：当日LTV/所选时间的消耗，该指标隔日产出，并做了模糊化处理',
  union_roi_3: '所选时间范围内的激活用户在激活后三日内的所有变现ROI，计算公式是：激活后三日LTV/所选时间的消耗，该指标隔日产出，并做了模糊化处理',
  union_roi_7: '所选时间范围内的激活用户在激活后七日内的整体变现ROI，计算公式是：激活后七日LTV/所选时间的消耗，该指标隔日产出，并做了模糊化处理',
  card_show: $bp_t('对于视频卡片类广告，在视频播放到3秒时进行卡片展现的数量。', 'bp.promotion_for_vedio_ad_play_second'),
  campaign_deny_word: $bp_t('您可在此列查看广告组下否定词的设置情况，点击本列可查询和编辑否定关键词。组否定词默认对组下所有计划生效，除非计划选择使用自定义否定词', 'bp.promotion_see_campaign_deny_word_sitatution'),
  luban_live_pay_order_count: '用户在您直播间的支付成功的订单量',
  luban_live_pay_order_stat_cost: '用户在您直播间的支付成功的订单金额，单位：元。',
  avg_rank: '显示您的选择的关键词所触发的搜索行为中，您的广告排在第几名。数据次日产出',
  play_over_rate: '计算公式：播放完成数/播放数。',
  convert_show_rate: '计算公式：转化数/展示数*100%。',
  dislike_cnt: '用户点击对广告不感兴趣的反馈的行为数量。',
  report_cnt: '用户认为广告质量较差而点击举报的行为数量。',
  play_over: '视频播放完成的次数，播放进度以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_duration_2s_rate: '计算公式：播放时长超过2秒的次数/播放数，播放时长以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_duration_3s_rate: '计算公式：播放时长超过3秒的次数/播放数，播放时长以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_duration_5s_rate: '计算公式：播放时长超过3秒的次数/播放数，播放时长以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_duration_10s_rate: '计算公式：播放时长超过3秒的次数/播放数，播放时长以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_25_feed_break_rate: '计算公式：播放时长超过25%进度的次数/播放数，播放进度以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_50_feed_break_rate: '计算公式：播放时长超过50%进度的次数/播放数，播放进度以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_75_feed_break_rate: '计算公式：播放时长超过75%进度的次数/播放数，播放进度以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  play_99_feed_break_rate: '计算公式：播放时长超过99%进度的次数/播放数，播放进度以播放终止时所在的视频时长来计算，包含拖拽等行为。',
  game_pay_count: '当天用户在应用内完成付费的总次数，多次付费会重复计数。',
  game_pay_cost: '当天用户在应用内完成付费的平均成本，计算方式：消耗/付费次数。',
  attribution_game_pay_7d_count: '用户激活应用后的7天内，在应用内完成付费的总次数，并将付费次数披露在每个用户的激活时间上。',
  attribution_game_pay_7d_cost: '用户激活应用后的7天内，在应用内完成付费的平均成本，计算方式：消耗/7日付费次数(激活时间)。',
  attribution_active_pay_7d_per_count: '7天内用户的平均付费次数，计算方式：7日付费次数（激活时间）/7日首次付费数(激活时间)，对首次付费数的统计仅在计划内去重且披露在每个用户的激活时间上。',
  luban_live_pay_order_count_by_author_3days: '最近一次通过广告触达用户之后，3日内在该主播的直播间带来的支付订单量',
  luban_live_pay_order_stat_cost_by_author_3days: '最近一次通过广告触达用户之后，3日内在该主播的直播间带来的支付订单金额，单位：元',
  luban_live_pay_order_count_by_author_7days: '最近一次通过广告触达用户之后，7日内在该主播的直播间带来的支付订单量',
  luban_live_pay_order_stat_cost_by_author_7days: '最近一次通过广告触达用户之后，7日内在该主播的直播间带来的支付订单金额，单位：元',
  luban_live_pay_order_count_by_author_15days: '最近一次通过广告触达用户之后，15日内在该主播的直播间带来的支付订单量',
  luban_live_pay_order_stat_cost_by_author_15days: '最近一次通过广告触达用户之后，15日内在该主播的直播间带来的支付订单金额，单位：元',
  luban_live_pay_order_count_by_author_30days: '最近一次通过广告触达用户之后，30日内在该主播的直播间带来的支付订单量',
  luban_live_pay_order_stat_cost_by_author_30days: '最近一次通过广告触达用户之后，30日内在该主播的直播间带来的支付订单金额，单位：元',
  wechat_login_count: '当天用户在微信内完成注册的总次数，将注册数记录在事件发生的时间上。例如，您的广告在8月20日展示给用户，用户点击广告后于8月23日在微信内产生注册行为，则这个注册行为将会展示在8月23日。',
  attribution_wechat_login_30d_count: '微信内注册行为发生（或回传）后，将注册行为记录到过去30天内的扣费（消耗产生）时间上。例如，广告在8月20日展示给用户，用户点击广告后于8月23日在微信内产生注册行为，则这个注册行为将会展示在8月20日，8月23日没有注册数。',
  wechat_login_cost: '当天用户在微信内完成注册的平均成本，计算公式：消耗/微信内注册数',
  attribution_wechat_login_30d_cost: '计算方式： 消耗 / 微信内注册数(计费时间)。例如，广告在8月20日展示给2位用户，此时广告计划10元，2位用户点击广告后于8月23日在微信内产生注册行为，则8月20日的微信内注册成本(计费时间) = 10/2=5元。',
  wechat_first_pay_count: '当天用户在微信内首次完成付费的总次数，将付费数记录在事件发生的时间上。例如，用户于8月20日产生注册行为，8月23日在微信内产生首次付费行为，则这个付费行为将会展示在8月23日。',
  attribution_wechat_first_pay_30d_count: '微信内付费行为发生（或回传）后，将付费行为记录到过去30天内的扣费（消耗产生）时间上。例如，广告在8月20日展示给用户，用户点击广告后于8月23日在微信内产生首次付费行为，则这个付费行为将会展示在8月20日，8月23日没有付费数。',
  wechat_first_pay_cost: '当天用户在微信内完成首次付费的平均成本，计算公式：消耗/微信内首次付费数',
  attribution_wechat_first_pay_30d_cost: '计算方式：消耗 / 微信内首次付费数（计费时间）。例如，广告在8月20日展示给2位用户，此时广告计划10元，2位用户点击广告后于8月23日在微信内产生首次付费行为，则8月20日的微信内首次付费成本(计费时间) = 10/2=5元。',
  wechat_first_pay_rate: '计算公式：微信内首次付费数/微信内注册数',
  attribution_wechat_first_pay_30d_rate: '计算公式：微信内首次付费数(计费时间)/微信内注册数(计费时间)',
  wechat_pay_count: '当天用户在微信内完成付费的总次数，多次付费会重复计数',
  attribution_wechat_pay_30d_count: '微信内付费行为发生（或回传）后，将付费行为记录到过去30天内的扣费（消耗产生）时间上。例如，广告在8月20日展示给用户，用户点击广告后于8月23日在微信内产生多次付费行为，则8月23日的多次付费行为将会展示在8月20日，8月23日没有付费次数。',
  wechat_pay_amount: '当天用户在微信内完成首次付费的总金额。',
  attribution_wechat_pay_30d_amount: '当天用户在微信内完成首次付费的总金额，将付费金额记录到过去30天内的扣费（消耗产生）时间上。例如，广告在8月20日展示给用户，用户点击广告后于8月23日在微信内产生首次付费行为，则这个首次付费金额将会展示在8月20日，8月23日没有首次付费金额。',
  attribution_wechat_pay_30d_per_count: '用户在微信内的平均付费次数，计算公式：微信内付费次数（计费时间）/微信内首次付费数（计费时间）',
  attribution_wechat_pay_30d_roi: '所选时间范围内的微信内首次付费ROI，计算公式：微信内首次付费金额（计费时间）/消耗。',
  game_in_app_ltv_1day: '所选时间范围内的激活用户，激活当日在APP内的付费金额。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_2days: '所选时间范围内的激活用户，激活后一天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_3days: '所选时间范围内的激活用户，激活后二天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_4days: '所选时间范围内的激活用户，激活后三天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_5days: '所选时间范围内的激活用户，激活后四天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_6days: '所选时间范围内的激活用户，激活后五天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_7days: '所选时间范围内的激活用户，激活后六天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_ltv_8days: '所选时间范围内的激活用户，激活后七天内在APP内的付费金额总和。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_1day: '所选时间范围内的激活用户在激活当日的付费ROI，计算公式是：当日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_2days: '所选时间范围内的激活用户在激活后一日内的所有付费ROI，计算公式是：激活后一日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_3days: '所选时间范围内的激活用户在激活后二日内的所有付费ROI，计算公式是：激活后二日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_4days: '所选时间范围内的激活用户在激活后三日内的所有付费ROI，计算公式是：激活后三日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_5days: '所选时间范围内的激活用户在激活后四日内的所有付费ROI，计算公式是：激活后四日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_6days: '所选时间范围内的激活用户在激活后五日内的所有付费ROI，计算公式是：激活后五日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_7days: '所选时间范围内的激活用户在激活后六日内的所有付费ROI，计算公式是：激活后六日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  game_in_app_roi_8days: '所选时间范围内的激活用户在激活后七日内的整体付费ROI，计算公式是：激活后七日付费金额/所选时间的消耗。该指标隔日产出，并做了模糊化处理。',
  luban_live_comment_cnt: '用户在您的直播间输入评论并点击发送消息的次数，目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  luban_live_share_cnt: '用户在您的直播间点击分享到其他社交媒体的次数，目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  luban_live_gift_cnt: '用户在您的直播间成功打赏的次数，目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  luban_live_gift_amount: '用户在您的直播间打赏的总金额，单位：音浪。目前仅支持鲁班直播、品牌Feeds Live直播和品牌TopLive直播',
  video_name: '视频素材的文件名字。',
  show_avg_uv_frequency: '每个用户看到广告的平均次数。仅对R&F计划生效，该指标次日产出。',
  show_1_more_frequency_uv: '至少查看过1次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_2_more_frequency_uv: '至少查看过2次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_3_more_frequency_uv: '至少查看过3次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_4_more_frequency_uv: '至少查看过4次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_5_more_frequency_uv: '至少查看过5次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_6_more_frequency_uv: '至少查看过6次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  show_7_more_frequency_uv: '至少查看过7次广告的用户数量。触达人数与展示数的不同在于同一个用户可能浏览广告多次，前者是人数，后者是次数。仅对优效智达的计划生效，该指标次日产出。',
  frequency: '优效智达广告设置的频次上限，广告投放后的人群触达次数小于此频控数据',
  month_frequency: '优效智达广告设置的频次上限，广告在投放后每个月内的人均触达频次小于此频控数据',
  week_frequency: '优效智达广告设置的频次上限，广告在投放后每周内的人均触达频次小于此频控数据',
  daily_frequency: '优效智达广告设置的频次上限，广告在投放后每天内的人均触达频次小于此频控数据',
  reach_target: '优效智达广告设置的周期内触达次数要求',
  play_duration_5s: '广告播放时间大于等于5秒的数量，如果视频总时长不足5秒，则记录播放完成的次数。',
  play_duration_15s: '广告播放时间大于等于15秒的数量，如果视频总时长不足15秒，则记录播放完成的次数。',
  real_recall_match_type: '用户搜索内容实际触发到您关键词的方式。',
  quality: '质量度是衡量关键词质量的综合性指标，在账户中以5星/10分的形式呈现。质量度越高意味着推广质量越优秀，同等条件下赢得网民的关注与认可的能力越强。',
  offlineSceneInventory: '按场景指定广告位下线，计划不可操作'
}

export const PromotionHeaderTipsHintLink = {
  pre_convert_count: {
    hintLink: '/academy/help/?category_id=6727070550100803587'
  }
}

export const InterfereStatus = {
  NotAllowStatus: 2,
  InterferingStatus: 3,
  InterfereEndStatus: 4,
  AgainAllowStatus: 5,
  SetRaiseCreation: 6,
  1: {
    title: $bp_t('开启一键起量', 'bp.promotion_promotion_state_open_upto_one'),
    desc: $bp_t('花一笔钱加速广告曝光', 'bp.promotion_promotion_state_speed_advertiser_show')
  },
  2: {
    title: $bp_t('不能开启一键起量', 'bp.promotion_promotion_state_close_upto_one')
  },
  3: {
    title: $bp_t('一键起量中', 'bp.promotion_promotion_state_one_button_lifting'),
    subTitle: $bp_t('起量报告', 'bp.promotion_promotion_state_one_button_lifting'),
    desc: $bp_t('期间请不要调整预算和出价', 'bp.promotion_promotion_state_adjust_budget_price')
  },
  4: {
    title: $bp_t('一键起量已结束', 'bp.promotion_promotion_state_upto_one_closed'),
    newTitle: $bp_t('重新开启', 'bp.promotion_promotion_state_open_upto_one'),
    subTitle: $bp_t('起量报告', 'bp.promotion_promotion_state_one_button_lifting')
  },
  5: {
    title: $bp_t('已预约起量', ''),
    subTitle: $bp_t('起量报告', 'bp.promotion_promotion_state_one_button_lifting'),
    disabled: true
  },
  6: {
    title: '预约一键起量',
    desc: '花一笔钱加速广告投放'
  }
}
export const FutureStarLevel = {
  // 普通计划
  normal: 0,
  // 普通潜力计划
  potential: 1,
  // 超级潜力计划
  superPotential: 2
}
export const SelectedTableRowClass = 'selected-row'

export let BatchingOperationOptionsForAd = {
  status: {
    name: $bp_t('状态', 'common.state'),
    isTitle: true
  },
  enable: {
    name: $bp_t('启用', 'common.enable')
  },
  disable: {
    name: $bp_t('暂停', 'common.suspend')
  },
  costAndBid: {
    name: $bp_t('出价和预算', 'bp.promotion_offer_and_budget'),
    isTitle: true
  },
  modifyCost: {
    name: $bp_t('更改出价', 'bp.promotion_change_bid')
  },
  modifyDpaBid: {
    name: $bp_t('更改深度转化出价', 'bp.modify_dpa_bid')
  },
  modifyBudget: {
    name: $bp_t('更改预算', 'bp.promotion_budget_change')
  },
  modifyTime: {
    name: $bp_t('更改时段', 'bp.promotion_change_period')
  },
  modifySchedule: {
    name: $bp_t('更改时间', 'bp.promotion_change_time')
  },
  userTarget: {
    name: $bp_t('用户定向', 'common.user_orientation'),
    isTitle: true
  },
  userTargetAge: {
    name: $bp_t('年龄', 'common.age')
  },
  userTargetDistrict: {
    name: $bp_t('地域', 'common.region')
  }
}

if (isSearchAdv) {
  BatchingOperationOptionsForAd = Object.assign(BatchingOperationOptionsForAd, {
    keyWord: {
      name: $bp_t('搜索广告', 'bp.const_campaign_search_advertising'),
      isTitle: true
    },
    addKeyWord: {
      name: $bp_t('添加否定词', 'bp.promotion_ad_priviate_word')
    },
    replaeceKeyWord: {
      name: $bp_t('替换否定词', 'bp.promotion_replace_priviate_word')
    },
    smartChoiceTraffic: {
      name: $bp_t('智选流量', 'common.smart_choice_traffic')
    },
    searchAutoUpdateKeyword: {
      name: '自动加词'
    },
    videoSync: {
      name: '创意视频引用'
    }

  })
}

if (isFeed2Search) {
  BatchingOperationOptionsForAd = Object.assign(BatchingOperationOptionsForAd, {
    feed2Search: {
      name: LegalText.promotion.feed_to_search
    }
  })
}
export const BatchingOperationOptionsForKeyword = {
  enable: {
    name: $bp_t('启用', 'common.enable')
  },
  pause: {
    name: $bp_t('暂停', 'common.suspend')
  },
  delete: {
    name: $bp_t('删除', 'common.delete')
  },
  matchType: {
    name: $bp_t('修改匹配方式', 'bp.promotion_keyword_modified_match_type')
  },
  wordBid: {
    name: $bp_t('修改词出价', 'bp.promotion_keyword_modified_word_bid')
  }
}

export const adlabCreateProcessStatus = {
  keeperCreatedOneStep: 1,
  keeperCreatedTwoStep: 2,
  keeperCreatedThreeStep: 3,
  keeperCreatedFourStep: 4,
  keeperCreatedFiveStep: 5,
  campaignCreated: 200,
  adGroupCreated: 201,
  creativeCreated: 202
}

export const warningSignOptions = {
  noSign: {
    value: 0,
    text: ''
  },
  // 创意预警
  creativeWarning: {
    value: 1,
    text: $bp_t('未上传创意，无法正常投放，请添加创意', '')
  },
  // 挤占预警
  squeezeWarning: {
    value: 2,
    text: $bp_t('由于CPT等独占订单投放，您的订单可能存在投放量不足的情况。如有此情况，您可以联系销售/代理进行补量', '')
  }

}
export const adlabDisabledText = '工具箱-投放管家商品推广投放流程已下线，功能禁用'
